export default () => ({
  user: {},
  roles: [],
  startUrl: '',
  loading: false,
});
